/* unplugin-vue-components disabled */import { render } from "./home_m.vue?vue&type=template&id=a8175e0a"
import script from "./home_m.vue?vue&type=script&lang=js"
export * from "./home_m.vue?vue&type=script&lang=js"

import "./home_m.vue?vue&type=style&index=0&id=a8175e0a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__